import React from "react";
import "./Environment_Condition.css"
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Environment_Condition_Form from "./Environment_Condition_Form/Environment_Condition_Form";
import Generate_Report_form from "./generate_Report_form/Generate_Report_form";

function Environment_Condition() {
  return (
    <>
      <section className="Imperiality ">
        <div className="back_div">
          <Common_Back_Btn backText="Environment Condition" />
        </div>

        <div className="imperiality_Form_div">
          <Environment_Condition_Form />
        </div>

        <div className="imperiality_Form_div">
          <Generate_Report_form />
        </div>

       
      </section>
    </>
  );
}

export default Environment_Condition;
